// SPDX-License-Identifier: AGPL-3.0-or-later

import {MuteDurationSheet} from '@app/features/app/components/bottomsheets/MuteDurationSheet';
import type {Channel} from '@app/features/channel/models/Channel';
import type {Guild} from '@app/features/guild/models/Guild';
import {useMuteSheet} from '@app/features/notification/hooks/useMuteSheet';
import {useChannelMenuData} from '@app/features/ui/action_menu/items/ChannelMenuData';
import {MenuBottomSheet} from '@app/features/ui/menu_bottom_sheet/MenuBottomSheet';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface ChannelBottomSheetProps {
	isOpen: boolean;
	onClose: () => void;
	channel: Channel;
	guild?: Guild;
}
export const ChannelBottomSheet: React.FC<ChannelBottomSheetProps> = observer(({isOpen, onClose, channel, guild}) => {
	const {t} = useLingui();
	const {muteSheetOpen, muteConfig, openMuteSheet, closeMuteSheet, handleMute, handleUnmute} = useMuteSheet({
		guildId: guild?.id ?? null,
		channelId: channel.id,
	});
	const {groups, state} = useChannelMenuData(channel, guild, {
		onClose,
		onOpenMuteSheet: openMuteSheet,
	});
	return (
		<>
			<MenuBottomSheet isOpen={isOpen} onClose={onClose} groups={groups} title={channel.name ?? t`Channel Options`} />
			<MuteDurationSheet
				isOpen={muteSheetOpen}
				onClose={closeMuteSheet}
				isMuted={state.isMuted}
				mutedText={state.mutedText}
				muteConfig={muteConfig}
				muteTitle={t`Mute Channel`}
				unmuteTitle={t`Unmute Channel`}
				onMute={handleMute}
				onUnmute={handleUnmute}
			/>
		</>
	);
});
